import { BaseReq, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";
import { getCurrentUserId } from "@/utils";
import moment from "moment";
// 基本信息
export class ReceiveInfoReq {
  signDate: string = moment().format("YYYY-MM-DD"); // 签收日期
  purchaseOrderId: string | undefined = undefined; // 关联采购订单 ID
  projectId: string | undefined = undefined; // 项目 ID
  projectName: string = ""; // 项目名称
  partyBCooperationCompanyId: string = ""; // 供应商 ID
  partyBCooperationCompanyName: string = ""; // 供应商名称
  logisticsNo: string = "WLDH00000000"; // 物流单号
  receiveTenantUserId: string = ''; // 收货人 ID
  verifyTenantUserId: string = ''; // 验收人
  receiveProvinceId: number = 0; // 收货省 ID
  receiveCityId: number = 0; // 收货市 ID
  receiveDistrictId: number = 0; // 收货区 ID
  receiveAddress: string = ""; // 收货详细地址
  receiveRemark: string = ""; // 验收说明
  remark: string = ""; // 备注
  bizImg: string[] = []; // 现场图片
  purchaseApplyId: string | undefined = undefined;
  repertotyId: string | undefined = undefined; // 选择仓库
}

// 收货明细
export class MaterialRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialModel: string = ""; // 规格型号
  materialBrand: string = ""; // 品牌
  materialUnit: string = ""; // 结算单位
  purchaseOrderCount: number = 0; // 订单采购数量
  cumulativeSignCount: number = 0; // 累计已签收量
  purchaseOrdertaxPrice: number = 0; // 采购单价-含税
  id: string = ""; // 收货单明细 ID
  currentAogCount: number = 0; // 本次到货数量
  currentAogTotalPrice: number = 0; // 本次收货金额
  currentSignCount: number = 0; // 本次签收数量
  projectId: string = ""; // 项目 ID
  purchaseOrderDetailId: string = ""; // 采购订单明细 ID
  purchaseReceiveOrderId: string = ""; // 收货订单 ID
  remark: string = ""; // 备注
  verifyRemark: string = ""; // 验收情况
  currentPutStorageCount: string = ""; // 已入库数量
  taxRate: number = 0; // 税率
  systemName:string = ""; //系统名称
  perfectCount: number = 0; // 良品数量
  defectiveCount: number = 0; // 次品数量
  sortFiled: number = 0; // 次品数量
}

export class ReceiveReq extends BaseReq {
  purchaseReceiveOrderInfoReq: ReceiveInfoReq = new ReceiveInfoReq(); // 基本信息
  purchaseReceiveOrderDetailReqs: MaterialRecord[] = []; // 收货明细
}

export class ReceivePageReq extends PaginationReq {
  projectName: string | undefined = undefined; // 项目名称
  bizNo: string | undefined = undefined; // 采购合同编号
  signStartDate: string | undefined = undefined; // 签收开始日期
  signEndDate: string | undefined = undefined; // 签收结束日期
  verifyTenantUserId: string | undefined = undefined; // 验收人
  storageStatus: string | undefined = undefined; // 入库状态
}

export class ReceiveListRecord extends UpdaterResp {
  id: number = 0; // 收货单 ID
  bidNo: string = ""; // 收货单编号
  signDate: string = ""; // 签收日期
  purchaseOrderId: string = ""; // 关联采购订单 ID
  purchaseOrderNo: string = ""; // 关联采购订单号
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  partyBCooperationCompanyName: string = ""; // 供应商
  verifyTenantUserId: string = ""; // 验收人 ID
  verifyTenantUserName: string = ""; // 验收人名称
  storageStatus: string = ""; // 入库状态
  storageStatusName: string = ""; // 入库状态
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class ReceivePageResp extends PaginationResp<ReceiveListRecord> {}

export class ReceiveSimpleRecord {
  id: string; // 收货验收 ID
  bizNo: string = ""; // 收货验收编号
  name: string = ""; // 收货验收名称
  projectId: string = ""; // 项目 ID
}

class DetailResp extends UpdaterResp {
  signDate: string = ""; // 签收日期
  purchaseOrderId: string | undefined = undefined; // 关联采购订单 ID
  purchaseOrderName: string = ""; // 关联采购订单 name
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  partyBCooperationCompanyId: string = ""; // 供应商 ID
  partyBCooperationCompanyName: string = ""; // 供应商名称
  supplierName: string = ""; // 供应商名称
  purchaseContractId: string = ""; // 合同
  purchaseContractName: string = ""; // 合同
  logisticsNo: string = ""; // 物流单号
  receiveTenantUserId: string = ""; // 收货人 ID
  verifyTenantUserId: string = ""; // 验收人
  receiveProvinceId: number = 0; // 收货省 ID
  receiveCityId: number = 0; // 收货市 ID
  receiveDistrictId: number = 0; // 收货区 ID
  receiveAddress: string = ""; // 收货详细地址
  receiveRemark: string = ""; // 验收说明
  totalReceivePrice: string = ""; //含税总金额
  remark: string = ""; // 备注
  bizImg: string[] = []; // 现场图片
  id: string = "";
}

export class ReceiveDetailResp {
  purchaseReceiveOrderAResp: DetailResp = new DetailResp();
  purchaseReceiveOrderDetailAResps: MaterialRecord[] = [];
  bizNo: string = "";
}

export class MaterialPageReq extends PaginationReq {
  id: string = ""; // 收货验收 ID
  materialName: string = ""; // 材料名称

  constructor(id) {
    super();
    this.id = id;
  }
}

export class MaterialPageResp extends PaginationResp<MaterialRecord> {}
